import { IQueryContext } from 'framework/context/IQueryContext';
import { IRosaEventsQueryParams, IRosaEventsResponse } from 'gen/ApiClient';
import React from 'react';

export const RosaCalendarQueryContext = React.createContext<IQueryContext<IRosaEventsResponse, IRosaEventsQueryParams>>(undefined as any);
